import { SubCategory } from './SubCategory';
import { TemplatedIntake } from './TemplatedIntake';
import { ProductDescriptionSlide } from './ProductDescriptionSlide';
import { Slide } from './index';
import { jsx as _jsx } from "react/jsx-runtime";
export var ActiveSlide = function ActiveSlide(_ref) {
  var activeSlide = _ref.activeSlide,
      initialTask = _ref.initialTask,
      initialTaskTitle = _ref.initialTaskTitle,
      initialError = _ref.initialError,
      isSubscriptionFlow = _ref.isSubscriptionFlow,
      onSubmitted = _ref.onSubmitted,
      todoEditType = _ref.todoEditType,
      setDoConfirmClose = _ref.setDoConfirmClose,
      setCurrentSlide = _ref.setCurrentSlide,
      onSlideClose = _ref.onSlideClose,
      confirmExit = _ref.confirmExit,
      setTaskTemplateId = _ref.setTaskTemplateId,
      taskTemplateId = _ref.taskTemplateId,
      categoryId = _ref.categoryId,
      setCurrentSlideToTemplated = _ref.setCurrentSlideToTemplated;

  if (activeSlide === Slide.SUB_CATEGORY) {
    return /*#__PURE__*/_jsx(SubCategory, {
      categoryId: categoryId,
      onSlideBack: function onSlideBack() {
        return setCurrentSlide(null);
      },
      onSlideClose: onSlideClose,
      onSubCategoryClick: function onSubCategoryClick(newTaskTemplateId, hasPdpStep) {
        setTaskTemplateId(newTaskTemplateId);

        if (hasPdpStep) {
          setCurrentSlide(Slide.PRODUCT_DESCRIPTION);
        } else {
          setCurrentSlide(Slide.TEMPLATED_TODO);
        }
      },
      onCreateCustomClicked: setCurrentSlideToTemplated
    });
  }

  if (activeSlide === Slide.PRODUCT_DESCRIPTION) {
    return /*#__PURE__*/_jsx(ProductDescriptionSlide, {
      onSlideBack: function onSlideBack() {
        return setCurrentSlide(Slide.SUB_CATEGORY);
      },
      onSlideClose: onSlideClose,
      onStartClick: function onStartClick(newTaskTemplateId) {
        setTaskTemplateId(newTaskTemplateId);
        setCurrentSlide(Slide.TEMPLATED_TODO);
      },
      taskTemplateId: taskTemplateId,
      initialError: initialError
    });
  }

  if (activeSlide === Slide.TEMPLATED_TODO) {
    return /*#__PURE__*/_jsx(TemplatedIntake, {
      onSlideBack: initialTask ? undefined : confirmExit(function () {
        return setCurrentSlide(Slide.SUB_CATEGORY);
      }),
      onSlideClose: onSlideClose,
      taskTemplateId: taskTemplateId !== null && taskTemplateId !== void 0 ? taskTemplateId : undefined,
      initialTask: initialTask,
      initialError: initialError,
      onDirtyChange: function onDirtyChange(dirty) {
        return setDoConfirmClose(dirty);
      },
      onSubmitted: onSubmitted,
      todoEditType: todoEditType,
      isSubscriptionFlow: isSubscriptionFlow,
      initialTaskTitle: initialTaskTitle
    });
  }
};